import styled from "styled-components/macro"

export const TenantSwitchWrap = styled.div`
  border-left: 0.0625rem solid #d8d8d8;
  padding-left: 10px;
  margin-left: 10px;
`
